import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";

const useUserDetails = () => {
    const { instance } = useMsal();
    const [userDetails, setUserDetails] = useState(null);

    useEffect(() => {
        const account = instance.getActiveAccount();
        if (account) {
            setUserDetails({
                username: account.username,
                name: account.name,
                userId: account.localAccountId || account.homeAccountId.split(".")[0],
                idTokenClaims: account.idTokenClaims
            });
        } else {
            // console.error("No active account found!");
        }
    }, [instance]);

    return userDetails;
};

export default useUserDetails;
